import React, {Component} from 'react';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Form, Grid,
  Header,
  Icon,
  Loader,
  Message,
  Modal, Responsive,
  Segment,
  Step
} from "semantic-ui-react";
import {checkEmail, checkRequired} from "../../shared/helpers/validators";
import {callService, GET, POST} from "../../shared/serviceInvoker";
import {DOLLAR_FORMAT, FULL_DATE_FORMAT, TIME_FORMAT} from "../../shared/helpers/formats";
import {availabilityHoursURL, scheduleAppointmentMeURL, scheduleAppointmentURL} from "../../shared/urls/clientapi";
import DateTimeSelector from "./daysHours";
import {isLoggedIn} from "../../shared/auth";
import moment from "moment";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';


const MIN_STEP = 1;
const MAX_STEP = 3;

const errors = {
  firstNameRequired: 'This field is required.',
  phoneRequired: 'This field is required.',
  emailValid: 'Add a valid email address.',
};


export default class AppointmentApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invalidUrl: false,
      errorLoading: false,
      loaded: false,

      showError1: false,
      showFormErrors: false,

      sending: false,
      errorSending: false,
      eventScheduled: false,

      teamId: null,
      open: true,

      hours: [],
      excludedDates: [],
      days: null,
      step: 1,

      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      approxDebt: '',
      agent: '',
      agentName: '',
      notes: '',

      firstNameRequired: false,
      phoneRequired: false,
      emailValid: true,
      valid: false,

      selectedDatetime: null,
    };

    this.scheduleAppointmentUrl = (isLoggedIn()) ? scheduleAppointmentMeURL: scheduleAppointmentURL;

    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);
    this.selectDatetime = this.selectDatetime.bind(this);

  }

  componentDidMount = () => {
    if (this.props.match && this.props.match.params) {
      const teamId = this.props.match.params.teamId;
      const url = availabilityHoursURL.replace('{team_id}', teamId);
      callService(
        GET,
        url,
        {},
        response => {
          const data = response.data.data;
          let agents = data.agents ?
            data.agents.map( (agentData) => {return {text: agentData.name, value: agentData.id}} )
          :
            [];
          agents.unshift({text: '', value: ''});
          if (data) {
            this.setState({
              days: data.days,
              hours: data.hours,
              excludedDates: data.excluded_dates,
              agents: agents,
              loaded: true,
            });
          }
          else {
            this.setState({errorLoading: true, });
          }
        },
        error => {
          this.setState({errorLoading: true, });
        }
      );
      this.setState({teamId: teamId, });
    }
    else {
      this.setState({invalidUrl: true, });
    }
  };

  selectDatetime = (day, hour, startOfHour) => {
    let selectedDatetime = moment(day);
    selectedDatetime.set({hour: hour, minute: ((startOfHour) ? 0 : 30), second: 0, millisecond: 0});
    this.setState({selectedDatetime: selectedDatetime, showError1: false, });
  };

  handleSubmit = () => {
    const { teamId, firstName, lastName, phone, email, approxDebt, agent, selectedDatetime, notes, } = this.state;
    const url = this.scheduleAppointmentUrl.replace('{team_id}', teamId);

    let starts = moment(selectedDatetime).format('YYYY-MM-DDTHH:mm:ss');
    let bodyFormData = new FormData();
    bodyFormData.append('first_name', firstName);
    bodyFormData.append('last_name', lastName);
    bodyFormData.append('phone_number', phone);
    bodyFormData.append('email', email);
    bodyFormData.append('special_note_1', approxDebt);
    bodyFormData.append('notes', notes);
    bodyFormData.append('starts', starts);
    if (agent) {
      bodyFormData.append('agent', parseInt(agent, 10));
    }
    this.setState({sending: true, });

    callService(
      POST,
      url,
      bodyFormData,
      response => {
        this.setState({sending: false, eventScheduled: true, errorSending: false, });

        let contact = "";
        if (sessionStorage.getItem("contact_id")) {
          contact = " Contact ID: (" + sessionStorage.getItem("contact_id") + ")";
        }

        let details = "Scheduled Appointment for " + firstName + " " + lastName + contact +" at " + starts;
        ReactGA.event({
          category: 'Schedule Appointment',
          action: details,
        });
        trackEvent('Schedule Appointment', details);

      },
      error => {
        this.setState({sending: false, errorSending: true, });
      }
    );
  };

  close = () => {
    this.setState({open: false, })
  };

  handleNext = () => {
    const { step, selectedDatetime, valid } = this.state;
    if (step === 1 && !selectedDatetime) {
      this.setState({showError1: true, });
    }
    else if (step === 2 && !valid) {
      this.setState({showFormErrors: true, });
    }
    else {
      this.setState({step: step + 1, finished: step >= MAX_STEP, showError1: false, showFormErrors: false, })
    }
  };

  handlePrev = () => {
    const { step } = this.state;
    if (step > MIN_STEP) {
      this.setState({step: step - 1, })
    }
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(
      {[name]: value},
      () => {this.validateField(name, value)}
    );
  };

  handleSelectChange = (event, { value }) => {
    const target = event.target;
    const text = target.innerText;
    this.setState({agent: value, agentName: text, });
  };

  validateField = (fieldName, value) => {
    let { emailValid, firstNameRequired, phoneRequired, } = this.state;
    switch(fieldName) {
      case 'email':
        emailValid = !value || checkEmail(value);
        break;
      case 'firstName':
        firstNameRequired = checkRequired(value);
        break;
      case 'phone':
        phoneRequired = checkRequired(value);
        break;
      default:
        break;
    }
    this.setState(
      {
        emailValid: emailValid, firstNameRequired: firstNameRequired, phoneRequired: phoneRequired,
      },
      this.validateForm
    )
  };

  validateForm() {
    let { emailValid, firstNameRequired, phoneRequired } = this.state;
    const valid = emailValid && firstNameRequired && phoneRequired;
    this.setState({valid: valid, });
  }

  render() {
    const {
      open, step, agents, firstName, lastName, phone, email, approxDebt, agent, agentName, notes, valid,
      firstNameRequired, selectedDatetime, phoneRequired, emailValid, hours, days, showError1, eventScheduled,
      sending, showFormErrors, loaded, errorLoading, errorSending, excludedDates,
    } = this.state;

    const scheduleText = 'Appointment scheduled on ' + FULL_DATE_FORMAT.format(selectedDatetime) + ' at ' + TIME_FORMAT.format(selectedDatetime);

    const form = (
      <Form onSubmit={this.handleSubmit}>
        <div className='field'>
          <Form.Input
            fluid
            error={!firstNameRequired && showFormErrors}
            type='text'
            name='firstName'
            label='First name *'
            value={firstName}
            onChange={this.handleInputChange} />
          {!firstNameRequired && showFormErrors && <div style={{ color: 'red' }}>{errors.firstNameRequired}</div>}
        </div>
        <Form.Input type='text' name='lastName' label='Last name' value={lastName} onChange={this.handleInputChange} fluid />
        <div className='field'>
          <Form.Input
            fluid
            error={!phoneRequired && showFormErrors}
            type='number'
            name='phone'
            label='Phone *'
            value={phone}
            onChange={this.handleInputChange} />
          {!phoneRequired && showFormErrors && <div style={{ color: 'red' }}>{errors.phoneRequired}</div>}
        </div>
        <div className='field'>
          <Form.Input
            fluid
            error={!emailValid && showFormErrors}
            type='email'
            name='email'
            label='Email'
            value={email}
            onChange={this.handleInputChange} />
          {!emailValid && showFormErrors && <div style={{ color: 'red' }}>{errors.emailValid}</div>}
        </div>
        <Form.Input
          fluid type='number'
          name='approxDebt'
          icon={<Icon color='green' name='dollar sign' />}
          iconPosition='left'
          label='Approx debt amount'
          value={approxDebt}
          onChange={this.handleInputChange} />
        {
          agents ?
            <Form.Select
              fluid
              selection
              search
              options={agents}
              name='agent'
              label='Preferred Agent'
              value={agent}
              onChange={this.handleSelectChange} />
            :
            null
        }
        <Form.TextArea label='Notes' name='notes' rows='5' value={notes} onChange={this.handleInputChange} />
      </Form>
    );

    const summary = (
      <Segment>
        <Segment vertical>{scheduleText}</Segment>
        <Segment vertical>
          <Header as='h4'>First Name:</Header> {firstName}
        </Segment>
        <Segment vertical>
          <Header as='h4'>Last Name:</Header> {lastName || ''}
        </Segment>
        <Segment vertical>
          <Header as='h4'>Phone Number:</Header> (+1) {phone}
        </Segment>
        <Segment vertical>
          <Header as='h4'>Email:</Header> {email || ''}
        </Segment>
        <Segment vertical>
          <Header as='h4'>Approximate Debt:</Header> {approxDebt ? DOLLAR_FORMAT.format(approxDebt) : ''}
        </Segment>
        {
          agent ?
            <Segment vertical>
              <Header as='h4'>Preferred Agent:</Header> {agentName}
            </Segment>
            :
            null
        }
        <Segment vertical>
          <Header as='h4'>Notes:</Header> {notes || ''}
        </Segment>
      </Segment>
    );

    return (
      <Container>
        <Divider hidden />
        <Message hidden={!errorLoading} content='There was an error contacting our servers. Please try again later!'/>
        <Message hidden={!eventScheduled} content='Thanks for contacting us! You can now close this window.'/>
        <Modal open={!errorLoading && open} centered={false} size='small'>

          <Modal.Header>
            <Container textAlign='center'>
              {
                !eventScheduled ?
                  <Button onClick={this.handlePrev} disabled={step === MIN_STEP} floated='left' color='blue' icon='angle left' />
                : null
              }
              <Responsive as={Step.Group} ordered size='mini' minWidth={768}>
                <Step active={step === 1} completed={step > 1}>
                  <Step.Content>
                    <Step.Title>
                      Times
                    </Step.Title>
                  </Step.Content>
                </Step>
                <Step active={step === 2} completed={step > 2}>
                  <Step.Content>
                    <Step.Title>
                      Information
                    </Step.Title>
                  </Step.Content>
                </Step>
                <Step active={step === 3} completed={eventScheduled}>
                  <Step.Content>
                    <Step.Title>
                      Review
                    </Step.Title>
                  </Step.Content>
                </Step>
              </Responsive>
              <Responsive as={Step.Group} vertical={false} size='mini' maxWidth={767}>
                <Step active={step === 1} completed={step > 1} className='small-step'>
                  <Step.Content>
                    <Step.Title>
                      Times
                    </Step.Title>
                  </Step.Content>
                </Step>
                <Step active={step === 2} completed={step > 2} className='small-step'>
                  <Step.Content>
                    <Step.Title>
                      Information
                    </Step.Title>
                  </Step.Content>
                </Step>
                <Step active={step === 3} completed={eventScheduled} className='small-step'>
                  <Step.Content>
                    <Step.Title>
                      Review
                    </Step.Title>
                  </Step.Content>
                </Step>
              </Responsive>

              {
                !eventScheduled ?
                  <Button onClick={this.handleNext} disabled={step === MAX_STEP} floated='right' color='blue' icon='angle right' />
                  : null
              }
            </Container>
          </Modal.Header>

          <Modal.Content scrolling className='appointment-content'>
            <Dimmer active={!loaded && !errorLoading}>
              <Loader>Loading</Loader>
            </Dimmer>
            <Container className={(step !== 1) ? 'hidden-content' : ''}>
              <Header textAlign='center'>Pick a Date & Time</Header>
              <Divider />
              <DateTimeSelector hours={hours} days={days} excludedDates={excludedDates} callback={this.selectDatetime} />
              <Message negative hidden={!showError1}>Please select a date.</Message>
            </Container>
            <Container className={(step !== 2) ? 'hidden-content' : ''}>
              <Header textAlign='center' as='h4'>{scheduleText}</Header>
              <Header textAlign='center'>Information</Header>

              <Responsive as={Grid} minWidth={768}>
                <Grid.Column width={3} />
                <Grid.Column width={10}>
                  {form}
                </Grid.Column>
                <Grid.Column width={3} />
              </Responsive>
              <Responsive maxWidth={767}>
                {form}
              </Responsive>

            </Container>
            <Container textAlign='center' className={(step !== 3) ? 'hidden-content' : ''}>
              <Header>
                <Icon name='list' />
                Your Appointment Summary
              </Header>
              <Container>
                <Responsive as={Grid} minWidth={768}>
                  <Grid.Column width={3} />
                  <Grid.Column width={10}>
                    {summary}
                  </Grid.Column>
                  <Grid.Column width={3} />
                </Responsive>
                <Responsive maxWidth={767}>
                  {summary}
                </Responsive>
                <Divider hidden className='mt-0'/>
                {
                  eventScheduled ?
                    <Header as='h3' color='blue'>
                      You have successfully scheduled your appointment. We look forward to speaking with you!
                    </Header>
                    :
                    <Button positive loading={sending} onClick={this.handleSubmit} disabled={!valid}>
                      <Icon name='calendar check outline' />
                      Schedule Appointment
                    </Button>
              }
                {
                  errorSending ?
                    <Message color='red' icon='cancel' content='An unexpected error occurred while scheduling your appointment. Please try again later!' />
                  :
                    null
                }
              </Container>
            </Container>
          </Modal.Content>

          <Modal.Actions>
            <Container textAlign='center'>
              <div>
                {
                  !eventScheduled ?
                    <Button floated='left' color='blue' disabled={step === MIN_STEP} onClick={this.handlePrev}>Prev</Button>
                  :
                    null
                }
                <Button negative onClick={this.close}>{!eventScheduled ? 'Cancel' : 'Close'}</Button>
                {
                  !eventScheduled ?
                    <Button floated='right' color='blue' disabled={step === MAX_STEP} onClick={this.handleNext}>Next</Button>
                  :
                    null
                }
              </div>
            </Container>
          </Modal.Actions>

        </Modal>
      </Container>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AppointmentApp/index.js